import { Text } from '~/shared/ui'
import type { GoldSetQueue } from '../model'

const formatNumber = (value: number) => value.toLocaleString('en-US')

export function GoldSetProgress({
  queue,
}: {
  queue: Pick<GoldSetQueue, 'done' | 'total' | 'done_by_me'>
}) {
  const percent = queue.total > 0 ? Math.min(100, (queue.done / queue.total) * 100) : 0
  const summary = `${formatNumber(queue.done)} of ${formatNumber(queue.total)} done · ${formatNumber(queue.done_by_me)} by you`

  return (
    <div className="flex min-w-[220px] flex-col gap-1">
      <Text appearance="BODY2">{summary}</Text>
      <div
        className="bg-surface-medium h-1.5 w-full overflow-hidden rounded-full"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={queue.total}
        aria-valuenow={queue.done}
      >
        <div
          className="bg-primary-main h-full rounded-full"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
